'use client'

import { useRouter } from 'next/navigation'
import { use, useEffect } from 'react'
import { useGetRestaurantQuery } from '@/api/restaurant/get-restaurant-query'
import { IRestaurantPageParams } from '@/app/[locale]/restaurants/[citySlug]/[restaurantSlug]/page'
import { RestaurantDetailContentModalVisual } from '@/features/restaurants/restaurant-detail/restaurant-detail-content-modal-visual'
import { UrlConfig } from '@/setup/routing'
import { IPageProps } from '@/typings/page-props'
import { useMobile } from '@/utils/window/use-mobile'

export default function VideoPage({
    params,
}: IPageProps<IRestaurantPageParams & { visualUuid: string }>) {
    const { restaurantSlug, citySlug, visualUuid } = use(params)
    const isMobile = useMobile()

    const router = useRouter()

    const { data } = useGetRestaurantQuery(restaurantSlug)

    const restaurant = data?.data

    useEffect(() => {
        if (typeof window === 'undefined' || isMobile === undefined) return

        if (!isMobile) {
            router.replace(
                UrlConfig['/restaurants/[citySlug]/[restaurantSlug]'].getUrl({
                    citySlug: citySlug,
                    restaurantSlug: restaurantSlug,
                    visualUuid: visualUuid,
                })
            )
        }
    }, [isMobile, router, restaurantSlug, citySlug, visualUuid])

    return (
        <div className="w-dvw h-dvh min-h-dvh min-w-dvw bg-white">
            {isMobile && restaurant && (
                <RestaurantDetailContentModalVisual
                    visualUuid={visualUuid}
                    citySlug={citySlug}
                    restaurant={restaurant}
                />
            )}
        </div>
    )
}
